module.exports = {
  menu: {
    // 企业简介
    srcQiYe: require("@/assets/images/PageTop/qiyejianjie.jpg"),
    // 业务范围
    rubber_img: require("@/assets/images/PageTop/jiance_cn.jpg"),
    // 公司动态
    CompanyDnamicImg: require("@/assets/images/PageTop/gongsidongtai.jpg"),
    // 行业质询
    InformationImg: require("@/assets/images/PageTop/hangyezixun.jpg"),
    // 实验室中心
    LaboratoryCenterImg: require("@/assets/images/PageTop/shiyanshizhongxin.jpg"),
    // 人才招聘
    RecruitmentImg: require("@/assets/images/PageTop/rencaizhaopin.jpg"),
    // 预约检查
    MakeAppointmentImg: require("@/assets/images/PageTop/yuyuejiance.jpg"),
    //申请表
    TestApplicationFormImg: require("@/assets/images/PageTop/jianceshenqingbiao.jpg"),
    // 报告查询
    TheReportQueryImg: require("@/assets/images/PageTop/baogaochaxun.jpg"),
    // 送检流程
    TheInspectionProcessImg: require("@/assets/images/PageTop/songjianliucheng.jpg"),
    // 调查和报价
    SurveyandQuotationImg: require("@/assets/images/PageTop/diaochahebaojia.jpg"),
    // 意见或建议
    OpinionOrAdviceImg: require("@/assets/images/PageTop/yijianhuojianyi.jpg"),
    CustomerInspectionImg: require("@/assets/images/PageTop/kehujiancexuzhi.jpg"),

    messageOne: "请输入用户名",
    messageTwo: "請輸入聯係電話",
    messageSan: "请输入邮箱",
    messageGongSi: "请输入公司名称",
    messageYiJian: "请输入意见或建议",

    placeholder: "请选择",
    nodatatext: "无数据",
    messageHeFaEamil: "请输入合法的邮箱",
    messageHeFaPhone: "请输入合法的手机号",

    KEYWords:
      "橡胶材料检测，塑料材料检测，橡塑材料检测，材料物理性能检测，司达行（广州）实验室有限公司，广州实验室公司，第三方检测机构、第三方检测实验室。",
    DEscription:
      "是一家具有独立法人的第三方检测实验室，依据《检验检测机构资质认定能力评价检验检测机构通用要求（RB/T214-2017）》和《检测和校准实验室能力认可准则（ISO/IEC 17025:2017）》建立并保持实验室管理体系，目前正在筹备CMA与CNAS认证认可工作。获批准后，将能够为客户提供认可的检测报告。业务范围：针对橡塑材料制品、日用品提供物理可靠性能项目的检测和服务，例如：高低温老化试验、硬度、拉伸、耐臭氧、耐磨试验等。",
    BTitle: "广州司达行航空密封制造有限公司检测中心",
    languageName: "简体",
    AboutUs: "关于我们",
    business: "检测范围",
    Rubber: "橡胶材料检测",

    PlasticMaterials: "塑料材料检测",
    OXinQuan: "O形圈检测",
    DianziDianGong: "电工电子产品检测",
    ZhiXun: "致电参观：",

    New: "新闻资讯",
    CompanyDnamic: "公司动态",
    IndustryInformation: "行业资讯",
    Team: "团队",

    LaboratoryCenter: "实验室中心", //2
    Recruitment: "人才招聘",
    customer: "客户服务",
    theDay: "预约检测",
    Testapplicationform: "检测申请表",
    TheReportQuery: "报告查询",
    TheInspectionProcess: "送检流程",
    contactUs: "联系我们",
    SurveyAndQuotation: "联系方式",
    suggestion: "意见或建议",
    Instructions: "客户检测须知",

    qiye: "实验室简介",
    viewMore: "查看更多",
    // business:"业务范围",

    particulars: "详情",

    CustomerInstructions: "客户检测须知",
    regulations: "客户在申请检测之前，请先了解相关条款及细则",
    introduce: "实验室介绍",
    ServicesAvailable: "检测项目",
    RongYu: "荣誉资质",
    USCDCLab: "实验室照片",
    laboratoryEquipment: "实验室设备",
    portal: "传送门",

    // DetectionOfConsulting:"检测咨询",
    ApplicationForm: "检测申请表下载",
    // TheInspectionProcess:"送检流程",
    // CommentsOrSuggestions:"意见或建议反馈",
    tijiaoChengGong: "发送成功",
    tijiaoError: "发送失败",

    // footer
    SweepYardsAttention: "扫码关注",
    WeChatOfficialAccount: "微信公众号",

    tel: "电话：",
    fax: "传真：",
    mailbox: "邮箱：",
    companyAddress: "地址：",
    businessHours: "营业时间：",
    detectionRange: " 检测范围：",

    CallUs: "致电我们",
    // 硬度试验
    briefIntroduction: "基本介绍",
    consult: "咨询",
    feedback: "反馈",
    testContent: "项目名称与检测内容",
    precautions: "检测周期与注意事项",
    ServiceContent: "服务内容",
    // testItem: "检测项目",
    advantages: "我们的优势",
    recommendation: "相关推荐",

    releaseDate: "发布时间：",
    source: "来源：",
    publisher: "发布者：",
    previousposts: "上一篇：",
    nextChapter: "下一篇：",
    // 留言模态框
    liuyan: "给我们留言",
    dianziemit: "电子邮箱",
    jobwork: "职位",
    country: "国/省/市",
    messageContents: "留言内容",
    shurucocntent: "请在此输入留言内容，我们会尽快与你联系",
    provide:
      "您所提供得个人资料将只会作为公司内部使用，而未来相关的市场资讯将会通过电邮及时通知您。",

    // 实验室
    LaboratoryPhotograph: "实验室照片",
    laboratoryEquipment: "实验室设备",
    deliver: "投递",

    WorkingArea: "上班地区：",
    recruitingNumbers: "招聘人数：",
    ExperienceRequirements: "经验要求：",
    educationalRequirements: "学历要求：",
    responsibilities: "工作职责:",
    jobRequirements: "任职要求:",

    jobtitle: "职位名称",
    reDate: "发布时间",
    // 投递信息
    deliveryOfInformation: "投递信息",
    name: "姓名",
    phone: "联系电话",
    // mailboxer:"电子邮箱",
    entryDate: "可到职日期",
    entryDateer: "选择日期",
    introduce: "自我介绍",
    offer:
      "  您所提供得个人资料将只会作为公司内部使用，而未来相关的市场资讯将会通过电邮及时通知您",
    SlectFile: "选择文件",

    send: "发送",
    reset: "重置",
    Select: "查询",

    // 申请表
    EntrustedTesting: "委托检测申请表",
    download: "下载",

    // 报告编号
    reportNumber: "报告编号",
    // InquiryTip:"  查询提示：报告查验可通过手机“扫一扫”报价单上生成的二维码来查询报告相关信息",
    ReportFiles:
      " （此处只支持查询结果）如索取报告请致电业务员。",
    salesman: "业务员：",

    searchResult: "查询结果",
    inputError: "输入有误，不存在相关的报告或资料（请与实验室相关人员联系）",
    applicationDate: "签发日期：",
    sampleName: "样品名称：",
    JianCeBiaoZhun: "检测标准：",
    testItemer: "型号规格：",
    testingResult: "检测结果：",
    TestCompletionDate: "备注：",
    confirm: "确定",

    testItem: "检测项目",
    companyName: "公司名称",
    // details:"意见或建议",
    // interior:"您所提供得个人资料将只会作为公司内部使用，而未来相关得市场资讯将会通过电邮及时通知您",
    pleaseAdvise:"请告知我们您的意见及建议，我们将认真研究您的建议，努力为您提供更优质更便捷的服务。",
    landlineMachine: "020-34773221转840",
},
content: {
      main: "这里是内容",
},
};
